import { render } from "./HeroiconsSolidIdentification.vue?vue&type=template&id=3f4eb722"
const script = {}

import exportComponent from "C:\\wamp64\\www\\systems\\nova-erp-system\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidIdentification.vue"]])

export default __exports__